/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { IReadOnlyListOfDailyActivityMonitoringLogHeaderSummaryDto } from './iReadOnlyListOfDailyActivityMonitoringLogHeaderSummaryDto.schema';

export const PagedResultOfDailyActivityMonitoringLogHeaderSummaryDto = zod.object({
  "items": zod.lazy(() => IReadOnlyListOfDailyActivityMonitoringLogHeaderSummaryDto).optional(),
  "pageNumber": zod.number().optional(),
  "pageSize": zod.number().optional(),
  "totalItems": zod.number().optional(),
  "totalPages": zod.number().optional(),
  "hasNextPage": zod.boolean().optional(),
  "hasPreviousPage": zod.boolean().optional()
});

export type PagedResultOfDailyActivityMonitoringLogHeaderSummaryDto = zod.input<typeof PagedResultOfDailyActivityMonitoringLogHeaderSummaryDto>;
export type PagedResultOfDailyActivityMonitoringLogHeaderSummaryDtoOutput = zod.output<typeof PagedResultOfDailyActivityMonitoringLogHeaderSummaryDto>;
